import { useState } from "react";
import search from "../../Assets/search.svg";
import styles from "./SearchBar.module.css";

const SearchBar = ({ onSearch, onRandomClick, text }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(searchTerm);
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSearch(searchTerm);
    }
  };

  return (
    <form className={styles.search_container} onSubmit={handleSubmit}>
      <img src={search} className={styles.img_holder} alt="Search" />
      <input
        type="text"
        placeholder={text}
        className={styles.search_input}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyDown={handleKeyDown}
        aria-label="Search"
      />
      <div className={styles.button_container}>
        <button
          type="submit"
          className={styles.search_button}
          aria-label="Search"
        >
          Search
        </button>
        {onRandomClick && (
          <button
            type="button"
            className={styles.random_button}
            onClick={onRandomClick}
            aria-label="Random recipe"
          >
            Surprise Me
          </button>
        )}
      </div>
    </form>
  );
};

export default SearchBar;
